import { Component } from '@angular/core';
import { LoadingMessageService } from '@bidvest/shared';

@Component({
  selector: 'bidvest-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'bidvest';

  public constructor(public readonly loadingMessageService: LoadingMessageService) {}
}
